import { actionCreatorFactory } from 'typescript-fsa';
import type { CartItems } from '@app/react/const/type';

const ac = actionCreatorFactory('ordermade');

export interface FetchInitProductSetItemParam {
    rid?: number | string | null;
}

export interface FetchInitProductSetItemResult {
    rid: number;
    designSet: CartItems;
}

export interface FetchInitProductSetItemError {
    status: number;
    statusText: string;
}

export const fetchInitProductSetItemAction = ac.async<
    FetchInitProductSetItemParam,
    FetchInitProductSetItemResult,
    FetchInitProductSetItemError
>('fetchInitProductSetItem');
